export default __webpack_public_path__ + "static/main_landing_page_qr-02c2ae9944fd91508350b60e3d0346e4.png";